class YotpoReviewsComponent extends HTMLElement {
  constructor() {
    super();
    this.appKey = this.getAttribute('app-key');
    this.productId = this.getAttribute('product-id');
    this.productName = this.getAttribute('product-name') || 'Product';
    // Only show 2 reviews initially
    this.initialPerPage = 2;
    this.perPage = parseInt(this.getAttribute('per-page')) || 5;
    this.currentPage = 1;
    this.totalReviews = 0;
    this.reviews = [];
    this.reviewTemplate = document.getElementById('review-template');
    this.reviewsContainer = document.getElementById('reviews-container');
    this.loadMoreBtn = document.getElementById('load-more-btn');
    this.averageRating = 0;
    this.loadingIndicator = this.reviewsContainer.querySelector('.ee-loading-indicator');
    this.productImageSource = document.getElementById('product-image-source');
    this.productImageUrl = this.productImageSource ? this.productImageSource.src : null;
    // Flag to prevent duplicate star rendering
    this.hasInitializedSummaryStars = false;
    // Track if we're on the initial load
    this.isInitialLoad = true;
    
    // Bind event handlers
    this.handleWriteReviewClick = this.handleWriteReviewClick.bind(this);
    this.loadMoreReviews = this.loadMoreReviews.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  async init() {
    try {
      // Initial fetch of reviews
      await this.fetchReviews();
      
      // Add event listener to load more button
      if (this.loadMoreBtn) {
        this.loadMoreBtn.addEventListener('click', () => {
          this.loadMoreReviews();
        });
      }
      
      // Add event listener for "Write a review" button
      this.setupWriteReviewButton();
    } catch (error) {
      console.error('Error initializing Yotpo reviews:', error);
    }
  }
  
  setupWriteReviewButton() {
    const writeReviewBtn = document.querySelector('.ee-reviews-write-btn');
    if (writeReviewBtn) {
      // Remove any existing event listeners
      writeReviewBtn.removeEventListener('click', this.handleWriteReviewClick);
      // Add our event listener
      writeReviewBtn.addEventListener('click', this.handleWriteReviewClick);
    }
  }
  
  handleWriteReviewClick(e) {
    e.preventDefault();
    
    // Check if Yotpo widget is available
    if (window.yotpo) {
      console.log('Using Yotpo widget to open review form');
      window.yotpo.showWidget('write-review-widget');
      return;
    }
    
    // Option 1: Open Yotpo review form in a new tab
    const yotpoWriteReviewUrl = `https://www.yotpo.com/go/write-review?appkey=${this.appKey}&product_id=${this.productId}&product_title=${encodeURIComponent(this.productName)}`;
    
    // Option 2: Open a modal with a custom review form
    this.openReviewModal();
    
    console.log('Write review button clicked, opening review form');
  }
  
  openReviewModal() {
    // Create modal if it doesn't exist
    let modal = document.getElementById('yotpo-review-modal');
    
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'yotpo-review-modal';
      modal.className = 'ee-review-modal';
      
      const modalContent = `
        <div class="ee-review-modal-content">
          <span class="ee-review-modal-close">&times;</span>
          <h2>Write a Review</h2>
          <form id="yotpo-review-form">
            <div class="ee-form-group">
              <label for="display_name">Your Name</label>
              <input type="text" id="display_name" name="display_name" required>
            </div>
            <div class="ee-form-group">
              <label for="email">Email</label>
              <input type="email" id="email" name="email" required>
            </div>
            <div class="ee-form-group">
              <label for="review_score">Rating</label>
              <div class="ee-star-rating">
                <input type="radio" id="star5" name="review_score" value="5" required>
                <label for="star5">5</label>
                <input type="radio" id="star4" name="review_score" value="4">
                <label for="star4">4</label>
                <input type="radio" id="star3" name="review_score" value="3">
                <label for="star3">3</label>
                <input type="radio" id="star2" name="review_score" value="2">
                <label for="star2">2</label>
                <input type="radio" id="star1" name="review_score" value="1">
                <label for="star1">1</label>
              </div>
            </div>
            <div class="ee-form-group">
              <label for="review_title">Review Title</label>
              <input type="text" id="review_title" name="review_title" required>
            </div>
            <div class="ee-form-group">
              <label for="review_content">Review Content</label>
              <textarea id="review_content" name="review_content" rows="4" required></textarea>
            </div>
            <button type="submit" class="ee-submit-review">Submit Review</button>
          </form>
        </div>
      `;
      
      modal.innerHTML = modalContent;
      document.body.appendChild(modal);
      
      // Disable scrolling function
      const disableScroll = () => {
        document.body.style.overflow = 'hidden';
      };
      
      // Enable scrolling function  
      const enableScroll = () => {
        document.body.style.overflow = '';
      };
      
      // Close button functionality
      const closeBtn = modal.querySelector('.ee-review-modal-close');
      closeBtn.addEventListener('click', () => {
        modal.style.display = 'none';
        enableScroll();
      });
      
      // Close when clicking outside the modal
      window.addEventListener('click', (event) => {
        if (event.target === modal) {
          modal.style.display = 'none';
          enableScroll();
        }
      });
      
      // Handle form submission
      const form = document.getElementById('yotpo-review-form');
      form.addEventListener('submit', (e) => this.submitReview(e));
    }
    
    // Show the modal and disable scrolling
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  
  submitReview(e) {
    e.preventDefault();
    
    const form = e.target;
    const formData = new FormData(form);
    const reviewData = {
      appkey: this.appKey,
      domain: window.location.origin,
      sku: this.productId,
      product_title: this.productName,
      product_description: this.productName,
      product_url: window.location.href,
      product_image_url: this.productImageUrl,
      display_name: formData.get('display_name'),
      email: formData.get('email'),
      review_content: formData.get('review_content'),
      review_title: formData.get('review_title'),
      review_score: parseInt(formData.get('review_score')),
      is_incentivized: false
    };
    
    const options = {
      method: 'POST',
      headers: {
        'accept': 'application/json', 
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reviewData)
    };
    
    fetch('https://api.yotpo.com/v1/widget/reviews', options)
      .then(res => res.json())
      .then(res => {
        console.log('Review submitted:', res);
        // Show success message
        const modal = document.getElementById('yotpo-review-modal');
        modal.innerHTML = `
          <div class="ee-review-modal-content">
            <span class="ee-review-modal-close">&times;</span>
            <h2>Thank You!</h2>
            <p>Your review has been submitted successfully.</p>
            <button class="ee-close-modal">Close</button>
          </div>
        `;
        
        // Add close functionality to button and X
        const closeBtn = modal.querySelector('.ee-review-modal-close');
        const closeModalBtn = modal.querySelector('.ee-close-modal');
        
        const closeModal = () => {
          modal.style.display = 'none';
          document.body.style.overflow = ''; // Re-enable scrolling
          // Refresh reviews
          setTimeout(() => this.fetchReviews(), 1000);
        };
        
        closeBtn.addEventListener('click', closeModal);
        closeModalBtn.addEventListener('click', closeModal);
      })
      .catch(err => {
        console.error('Error submitting review:', err);
        alert('There was an error submitting your review. Please try again later.');
      });
  }

  async fetchReviews() {
    try {
      // Show loading indicator
      if (this.loadingIndicator) {
        this.loadingIndicator.style.display = 'block';
      }
      
      // Use initialPerPage for the first load, perPage for subsequent loads
      const perPageToUse = this.isInitialLoad ? this.initialPerPage : this.perPage;
      
      // Different URL construction based on initial load or not
      let url;
      if (this.isInitialLoad) {
        // Initial load - just get first 2 reviews
        url = `https://api-cdn.yotpo.com/v1/widget/${this.appKey}/products/${this.productId}/reviews.json?page=1&per_page=${this.initialPerPage}`;
      } else if (this.currentPage === 1) {
        // First load more - get perPage reviews (skipping the already loaded initial reviews)
        url = `https://api-cdn.yotpo.com/v1/widget/${this.appKey}/products/${this.productId}/reviews.json?page=1&per_page=${this.perPage}`;
      } else {
        // Normal pagination for subsequent pages
        url = `https://api-cdn.yotpo.com/v1/widget/${this.appKey}/products/${this.productId}/reviews.json?page=${this.currentPage}&per_page=${this.perPage}`;
      }
      
      const response = await fetch(url);
      const data = await response.json();
      
      // Hide loading indicator
      if (this.loadingIndicator) {
        this.loadingIndicator.style.display = 'none';
      }
      
      if (data.status && data.status.code === 200) {
        // Update total reviews count
        this.totalReviews = data.response.pagination.total;
        document.getElementById('total-reviews').textContent = this.totalReviews;
        
        // Get the average score from response if available
        if (data.response.bottomline && data.response.bottomline.average_score) {
          this.averageRating = data.response.bottomline.average_score;
          const scoreElement = document.querySelector('.ee-reviews-score');
          if (scoreElement) {
            scoreElement.textContent = this.averageRating.toFixed(1);
          }
        }
        
        // Get product image URL if not already set and no custom image is provided
        if (!this.productImageUrl && data.response.products && data.response.products[0]) {
          const product = data.response.products[0];
          if (product.image_url) {
            this.productImageUrl = product.image_url;
            this.productName = product.name || this.productName;
          }
        }
        
        if (!this.isInitialLoad && this.currentPage === 1) {
          // If this is the first "load more" click, clear the initial reviews and show all from page 1
          this.reviewsContainer.innerHTML = '';
          if (this.loadingIndicator) {
            this.reviewsContainer.appendChild(this.loadingIndicator);
          }
          this.reviews = data.response.reviews;
          this.renderReviews(data.response.reviews);
        } else {
          // Append new reviews to the array for initial load or subsequent pages
          this.reviews = [...this.reviews, ...data.response.reviews];
          this.renderReviews(data.response.reviews);
        }
        
        // Update load more button visibility
        this.updateLoadMoreButton();
        
        // Update stars in the summary
        this.updateSummaryStars();
        
        // No longer on initial load after fetching
        this.isInitialLoad = false;
      } else {
        console.error('Error fetching reviews:', data);
      }
    } catch (error) {
      console.error('Error fetching reviews:', error);
      // Hide loading indicator in case of error
      if (this.loadingIndicator) {
        this.loadingIndicator.style.display = 'none';
      }
    }
  }

  renderReviews(reviews) {
    reviews.forEach(review => {
      const reviewElement = this.createReviewElement(review);
      this.reviewsContainer.appendChild(reviewElement);
    });
  }

  createReviewElement(review) {
    const reviewClone = this.reviewTemplate.content.cloneNode(true);
    
    // Set reviewer name and initial
    const displayName = review.user.display_name || 'Anonymous';
    const nameElement = reviewClone.querySelector('.ee-reviewer-name');
    nameElement.textContent = displayName;
    
    const initialElement = reviewClone.querySelector('.ee-reviewer-initial');
    initialElement.textContent = displayName.charAt(0).toUpperCase();
    
    // Show/hide verified buyer badge
    const verifiedBuyer = reviewClone.querySelector('.ee-reviewer-verified');
    verifiedBuyer.style.display = review.verified_buyer ? 'flex' : 'none';
    
    // Show/hide recommendation
    const recommendElement = reviewClone.querySelector('.ee-recommend');
    recommendElement.style.display = review.is_incentivized ? 'flex' : 'none';
    
    // Set review stars - create actual star elements instead of using CSS
    const ratingElement = reviewClone.querySelector('.ee-review-rating');
    ratingElement.innerHTML = ''; // Clear any existing content
    
    // Create the star rating manually for each review
    const score = review.score || 5;
    for (let i = 1; i <= 5; i++) {
      const star = document.createElement('span');
      star.textContent = i <= score ? '★' : '☆';
      star.style.color = '#f8b84e';
      star.style.fontSize = '18px';
      star.style.letterSpacing = '3px';
      ratingElement.appendChild(star);
    }
    
    // Set review time
    const reviewTime = reviewClone.querySelector('.ee-review-time');
    // Format date (16 h format as shown in the design)
    const date = new Date(review.created_at);
    const now = new Date();
    const diffHours = Math.round((now - date) / (1000 * 60 * 60));
    
    if (diffHours < 24) {
      reviewTime.textContent = `${diffHours} h`;
    } else {
      const diffDays = Math.round(diffHours / 24);
      reviewTime.textContent = `${diffDays} d`;
    }
    
    // Set review title and content
    const titleElement = reviewClone.querySelector('.ee-review-title');
    titleElement.textContent = review.title || 'Review';
    
    const contentElement = reviewClone.querySelector('.ee-review-content');
    contentElement.textContent = review.content;
    
    // Add review images if available
    const imageContainer = reviewClone.querySelector('.ee-review-image-container');
    if (review.images_data && review.images_data.length > 0) {
      review.images_data.forEach(imageData => {
        const img = document.createElement('img');
        img.src = imageData.thumb_url;
        img.alt = 'Review image';
        img.classList.add('ee-review-image');
        imageContainer.appendChild(img);
      });
    } else {
      imageContainer.style.display = 'none';
    }
    
    // Add product image to each review
    const productImageContainer = reviewClone.querySelector('.ee-product-image-container');
    if (this.productImageUrl && productImageContainer) {
      const img = document.createElement('img');
      img.src = this.productImageUrl;
      img.alt = this.productName;
      img.className = 'ee-product-image';
      img.width = 120;
      img.height = 120;
      productImageContainer.appendChild(img);
    } else {
      productImageContainer.style.display = 'none';
    }
    
    // Set helpful counts
    const upVoteCount = reviewClone.querySelector('[data-vote="up"] .ee-helpful-count');
    upVoteCount.textContent = review.votes_up;
    
    const downVoteCount = reviewClone.querySelector('[data-vote="down"] .ee-helpful-count');
    downVoteCount.textContent = review.votes_down;
    
    // Add event listeners for helpful buttons
    const helpfulButtons = reviewClone.querySelectorAll('.ee-helpful-btn');
    helpfulButtons.forEach(button => {
      button.addEventListener('click', () => {
        const voteType = button.getAttribute('data-vote');
        this.submitVote(review.id, voteType === 'up');
        
        // Update count for better UX even before API response
        const countElement = button.querySelector('.ee-helpful-count');
        countElement.textContent = (parseInt(countElement.textContent) || 0) + 1;
        
        // Disable both buttons after voting
        helpfulButtons.forEach(btn => btn.disabled = true);
      });
    });
    
    return reviewClone.querySelector('.ee-review-item');
  }

  async submitVote(reviewId, isUpVote) {
    try {
      const url = `https://api.yotpo.com/reviews/${reviewId}/vote/${isUpVote ? 'up' : 'down'}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          appkey: this.appKey,
        }),
      });
      
      const data = await response.json();
      if (!data.status || data.status.code !== 200) {
        console.error('Error submitting vote:', data);
      }
    } catch (error) {
      console.error('Error submitting vote:', error);
    }
  }

  loadMoreReviews() {
    if (this.isInitialLoad || (this.currentPage === 1 && this.reviews.length <= this.initialPerPage)) {
      // First load more - stay on page 1 but get all reviews
      this.isInitialLoad = false;
      this.fetchReviews();
    } else {
      // Normal pagination for subsequent clicks
      this.currentPage++;
      this.fetchReviews();
    }
  }

  updateLoadMoreButton() {
    if (this.totalReviews <= this.initialPerPage) {
      // If there are fewer than or equal to initialPerPage reviews total, hide the button
      this.loadMoreBtn.style.display = 'none';
    } else if (this.isInitialLoad) {
      // If on initial load and there are more reviews, show the button
      this.loadMoreBtn.style.display = 'inline-block';
    } else if (this.reviews.length >= this.totalReviews) {
      // If we've loaded all reviews, hide the button
      this.loadMoreBtn.style.display = 'none';
    } else {
      // Otherwise, show the button
      this.loadMoreBtn.style.display = 'inline-block';
    }
  }

  updateSummaryStars() {
    const starsContainer = document.querySelector('.ee-reviews-stars');
    if (starsContainer) {
      // Use the fetched average rating
      this.createStarRating(starsContainer, this.averageRating);
      this.hasInitializedSummaryStars = true;
    }
  }
  
  createStarRating(container, rating) {
    container.innerHTML = '';
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    
    for (let i = 1; i <= 5; i++) {
      const star = document.createElement('span');
      if (i <= fullStars) {
        star.textContent = '★';
      } else if (i === fullStars + 1 && hasHalfStar) {
        star.textContent = '★'; // we don't have half-star character, using full for simplicity
      } else {
        star.textContent = '☆';
      }
      star.style.color = '#f8b84e';
      star.style.fontSize = '26px';
      star.style.letterSpacing = '5px';
      container.appendChild(star);
    }
  }
}

// Register the web component
customElements.define('yotpo-reviews-component', YotpoReviewsComponent);

// Initialize rating stars in the summary - now done by the component
document.addEventListener('DOMContentLoaded', () => {
  // Only initialize stars if the component hasn't done it yet
  // We'll use a setTimeout to wait a bit for the component to load
  setTimeout(() => {
    const component = document.querySelector('yotpo-reviews-component');
    if (component && !component.hasInitializedSummaryStars) {
      const starsContainer = document.querySelector('.ee-reviews-stars');
      if (starsContainer) {
        // Only create stars if the container is empty
        if (starsContainer.children.length === 0) {
          const scoreElement = document.querySelector('.ee-reviews-score');
          const rating = scoreElement ? parseFloat(scoreElement.textContent) : 5;
          
          // Create stars manually
          for (let i = 1; i <= 5; i++) {
            const star = document.createElement('span');
            star.textContent = i <= Math.floor(rating) ? '★' : '☆';
            star.style.color = '#f8b84e';
            star.style.fontSize = '26px';
            star.style.letterSpacing = '5px';
            starsContainer.appendChild(star);
          }
        }
      }
    }
  }, 500); // Wait 500ms for component to initialize

  // Debug code for write review button
  setTimeout(() => {
    const writeReviewBtn = document.querySelector('.ee-reviews-write-btn');
    if (writeReviewBtn) {
      console.log('Debug: Write review button found in DOM');
      
      // Add a direct event listener to help debug
      writeReviewBtn.addEventListener('click', function(e) {
        console.log('Debug: Write review button direct click handler fired');
        // Don't prevent default here, just log
      });
      
      // Check if button is properly clickable
      const rect = writeReviewBtn.getBoundingClientRect();
      console.log('Debug: Button position:', {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        isVisible: rect.width > 0 && rect.height > 0
      });
    } else {
      console.log('Debug: Write review button NOT found in DOM');
    }
  }, 1000); // Check after 1 second to ensure DOM is ready
}); 